import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, forkJoin, map, of } from 'rxjs';
import { CommonService, MetricService } from '../../api/services';
import { AuthService } from '../../services/auth.service';
import { MetricCatalogService } from '../../services/metric-catalog.service';

export const configGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const common = inject(CommonService);
  const metricService = inject(MetricService);
  const auth = inject(AuthService);
  const metricCatalog = inject(MetricCatalogService);

  const roles$ =
    auth.appRoles.length === 0
      ? common.commonControllerFindRoles().pipe(
          map((response) => (auth.appRoles = response.data.roles)),
          catchError((error) => of({ reason: 'roles' })),
        )
      : of(auth.appRoles);

  const metrics$ = !metricCatalog.loaded()
    ? metricService.metricControllerFindAllMetric({ limit: 0 }).pipe(
        map((response) => metricCatalog.load(response.data.list)),
        catchError((error) => of({ reason: 'metrics' })),
      )
    : of(metricCatalog.metrics());

  return forkJoin({ roles: roles$, metrics: metrics$ }).pipe(
    map(() => true),
    catchError((error) => {
      return of(new RedirectCommand(router.parseUrl(`/login-error${error.reason ? `?reason=${error.reason}` : ''}`)));
    }),
  );
};

export const rolesGuardCanActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  return (route.data['roles'] as Array<any>).some((r) => auth.appRoles.map((x) => x.name).includes(r));
};
